import baseStorage from 'redux-persist/lib/storage';

const prefix = 'persist:';

const shouldSkipCleanupKeys = [
  `${prefix}loans/balanceTableOpts`,
  `${prefix}retainers/balanceTableOpts`,
  `${prefix}trading/balanceTableOpts`,
  `${prefix}tradingTasks/filter`,
  `${prefix}calculatedThresholds`,
  `${prefix}loans/sidebar`,
  `${prefix}trading/sidebar`,
  `${prefix}retainers/sidebar`,
  `${prefix}vault/sidebar`,
  `${prefix}tasks`,
];

// Custom storage with conditional removeItem
const storageCustom = {
  ...baseStorage,
  removeItem: async (key: string) => {
    if (shouldSkipCleanupKeys.includes(key)) {
      return;
    }
    return baseStorage.removeItem(key);
  },
};

export default storageCustom;
